Core.CustomersRouter = Core.SubRouter.extend({
    routes: {
        '': 'customers',
        'new': 'createCustomer',
        ':id': 'viewCustomer',
        ':id/edit': 'editCustomer',
        ':customerId/customerproject/:customerProjectId': 'viewCustomerProject',
        ':customerId/customerproject/:customerProjectId/edit': 'editCustomerProject',
    },

    customers: function () {
      app.setMainView(new CustomerListView({scrolling: true}), 'directory');
    },

    createCustomer: function () {
      app.setMainView(new CustomerDetailsView({editing: true}), 'directory');
    },

    viewCustomer: function (id) {
        app.setMainView(new CustomerDetailsView({id: id}), 'directory');
    },

    editCustomer: function (id) {
        app.setMainView(new CustomerDetailsView({id: id, editing: true}), 'directory');
    },

    viewCustomerProject: function(customerId, customerProjectId) {
        app.setMainView(new CustomerDetailsView({id: customerId, customerProjectId: customerProjectId}), 'directory');
    },

    editCustomerProject: function(customerId, customerProjectId) {
        app.setMainView(new CustomerDetailsView({id: customerId, customerProjectId: customerProjectId, editingCustomerProject: true}), 'directory');
    },

});
